function postfixObjKeys(obj, postfix) {
  return Object.fromEntries(Object.entries(obj).map(function(param) {
    var [k, v] = param;
    return [
      `${k}${postfix}`,
      v
    ];
  }));
}
function sizeToSpace(v) {
  if (v === 0) return 0;
  if (v === 2) return 0.5;
  if (v === 4) return 1;
  if (v === 8) return 1.5;
  if (v <= 16) return Math.round(v * 0.333);
  return Math.floor(v * 0.7 - 12);
}
function objectFromEntries(arr) {
  return Object.fromEntries(arr);
}
function objectKeys(obj) {
  return Object.keys(obj);
}
export {
  objectFromEntries,
  objectKeys,
  postfixObjKeys,
  sizeToSpace
};
//# sourceMappingURL=utils.js.map
